module.exports = __webpack_public_path__ + "static/media/mso_login.d73b830c.png";